import styled from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
const sizeToPx = {
    small: 20,
    medium: 24,
};
export const StyledButton = styled.button `
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ $size }) => pxToRem(sizeToPx[$size])};
  height: ${({ $size }) => pxToRem(sizeToPx[$size])};
  background-color: ${({ $selected }) => ($selected ? theme.semantic.surface.inverse : theme.semantic.surface.primary)};
  border: ${pxToRem(1)} solid
    ${({ $selected }) => ($selected ? theme.swatches.warm[700] : theme.semantic.border.strong)};
  border-radius: ${theme.borderRadius.circle};
  outline: ${pxToRem(0)} solid transparent;
  transition: outline 0.1s ease-in-out;

  &:focus-visible {
    box-shadow: 0 0 0 ${pxToRem(4)} ${theme.semantic.focus.ring};
  }

  &:hover:not(:disabled) {
    background-color: ${({ $selected }) => ($selected ? theme.swatches.warm[800] : theme.swatches.warm[200])};
  }

  &:active:not(:disabled) {
    outline: ${pxToRem(2)} solid ${theme.semantic.border.default};
  }

  &:disabled {
    opacity: 0.5;
  }
`;
